export const NAVBAR_MOBILE_HEIGHT = 58;
export const NAVBAR_DESKTOP_HEIGHT = 72;
